module.exports = __webpack_public_path__ + "static/media/20b-03_ST-2020-435x510mm-oleo-sobre-madera.9d5a8e5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20b/20b-03_ST-2020-435x510mm-oleo-sobre-madera.jpg
// module id = 248
// module chunks = 0